import PropTypes from "prop-types";
import defaultStyle from "./styles";

const PremierCountry = ({ countryData, assetsUrl, style = defaultStyle }) => (
  <div className={style.PremierCountry}>
    <div className={style.PremierImage}>
      <img
        src={`${assetsUrl}/premier-landing-page/img/svg/${countryData.country.code.toLowerCase()}.svg`}
        alt=""
      />
    </div>
    <p className={style.PremierCountryName}>{countryData.country.name}</p>
  </div>
);

PremierCountry.propTypes = {
  countryData: PropTypes.shape({
    country: PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }),
  assetsUrl: PropTypes.string,
  style: PropTypes.object,
};

export default PremierCountry;
